import {
  forEach,
  isEmpty,
  compose,
  filter,
  pathOr,
  sortBy,
  prop,
  last,
  path,
  map,
} from "ramda";
import {
  statusValues,
  statusMapParser,
  advancementImageURLPrefix,
} from "../constants/advancements";
import { parseStatus } from "../advancements";
import { isPropNotEmpty } from "../object";

const transformLinkedAdventure = (adventure, electiveAdventure) => {
  if (path(["id"], adventure)) {
    return {
      ...adventure,
      electiveAdventure: electiveAdventure || false,
      status: adventure.status ? adventure.status.toLowerCase() : "",
    };
  }
  return null;
};

const getElectiveAdventure = (electives) => {
  // check for completed adventures first
  const completedElectives = compose(
    sortBy(prop("dateCompleted")),
    filter(
      (elective) =>
        statusValues[parseStatus(elective.status)] >= statusValues.COMPLETED
    ),
    map((elective) => transformLinkedAdventure(elective))
  )(electives);

  // if completed electives return the first completed
  if (!isEmpty(completedElectives)) {
    return completedElectives[0];
  }

  // if not elective completed return the elective with higher progress
  const inProgressElectives = compose(
    sortBy(prop("percentCompleted")),
    map((elective) => transformLinkedAdventure(elective)),
    filter((elective) => elective.percentCompleted > 0)
  )(electives);

  if (!isEmpty(inProgressElectives)) {
    return last(inProgressElectives);
  }

  // if not completed or in progress elective return empty
  return {};
};

const getDefaultAdventure = (requirement) => ({
  id: +requirement.linkedAdventureId,
  name: requirement.name,
  electiveAdventure: requirement.electiveAdventure,
  imageUrl100: `${advancementImageURLPrefix}adventures/${requirement.linkedAdventureId}_100.png`,
  imageUrl200: `${advancementImageURLPrefix}adventures/${requirement.linkedAdventureId}_200.png`,
  imageUrl300: `${advancementImageURLPrefix}adventures/${requirement.linkedAdventureId}_300.png`,
});

const getRequirementAdventures = (requirement = {}) => {
  const adventures = [];
  let electiveAdventuresAdded = false;
  if (isPropNotEmpty(requirement, "requirements")) {
    forEach((req) => {
      if (isPropNotEmpty(req, "linkedAdventure")) {
        adventures.push(
          transformLinkedAdventure(
            req.linkedAdventure,
            requirement.electiveAdventure
          )
        );
      } else if (isPropNotEmpty(req, "linkedAdventureId")) {
        adventures.push(getDefaultAdventure(req));
      } else if (
        isPropNotEmpty(req, "linkedElectiveAdventures") &&
        !electiveAdventuresAdded
      ) {
        adventures.push(
          ...map(
            (adventure) =>
              transformLinkedAdventure(adventure, req.electiveAdventure),
            req.linkedElectiveAdventures
          )
        );
        electiveAdventuresAdded = true;
      }
    }, pathOr([], ["requirements"], requirement));
  } else if (isPropNotEmpty(requirement, "linkedAdventure")) {
    adventures.push(
      transformLinkedAdventure(
        requirement.linkedAdventure,
        requirement.electiveAdventure
      )
    );
  } else if (isPropNotEmpty(requirement, "linkedAdventureId")) {
    adventures.push(getDefaultAdventure(requirement));
  }
  return adventures;
};

export default getRequirementAdventures;
